/* eslint-disable array-callback-return */
import React from "react";
import { RouteProps } from "react-router";
import styled from "styled-components/macro";
import { HomeHero } from "../components/pages/home/HomeHero";
import { HomeText } from "../components/pages/home/HomeText";
import { HomeProducts } from "../components/pages/home/products/HomeProducts";
import { HomePromo } from "../components/pages/home/promos/HomePromo";
import { HomePromos } from "../components/pages/home/promos/HomePromos";
import useHome, { HomeContentType } from "../hooks/api/queries/useHome";

export const Home: React.FC<RouteProps> = (props) => {
  const { data } = useHome();

  if (!data) return null;

  return (
    <Container>
      {data
        ?.sort((a, b) => a.sorting - b.sorting)
        ?.map((item) => {
          switch (item.contentType) {
            case HomeContentType.HOME_HERO:
              return (
                <React.Fragment key={`home-${item.id}`}>
                  <HomeHero item={item} />
                </React.Fragment>
              );
            case HomeContentType.HOME_PRODUCTS_PUSH:
              return (
                <React.Fragment key={`home-${item.id}`}>
                  <HomeProducts item={item} />
                </React.Fragment>
              );
            case HomeContentType.HOME_PROMO_PUSH:
              return (
                <React.Fragment key={`home-${item.id}`}>
                  <HomePromo item={item} />
                </React.Fragment>
              );
            case HomeContentType.HOME_TEXT:
              return (
                <React.Fragment key={`home-${item.id}`}>
                  <HomeText item={item} />
                </React.Fragment>
              );
            case HomeContentType.HOME_FOOTER_PROMO_PUSH:
              return (
                <React.Fragment key={`home-${item.id}`}>
                  <HomePromos item={item} />
                </React.Fragment>
              );
            default:
              <></>;
          }
        })}
    </Container>
  );
};

const Container = styled.div`
  min-height: 101vh;
`;
